// extracted by mini-css-extract-plugin
export default {"ProjectSidebar":"ProjectSidebar_ProjectSidebar__hkSAu","ProjectSidebarItem":"ProjectSidebar_ProjectSidebarItem__LD+x-"};